<template>
    <div>
        <div :is="tabContent" :user-type="userTypes.customer" :open-id="$store.state.user.openId" @addconsult="addConsult"></div>
      <van-tabbar v-model="active" background="blue">
            <van-tabbar-item icon="home-o">新建</van-tabbar-item>
            <van-tabbar-item  icon="chat-o">全部公告</van-tabbar-item>
        </van-tabbar>
		
	</div>
</template>

<script>
    import NoticeList from './NoticeList';
    import AddNotice from './AddNotice'
    import {userTypes} from '../common/const'
  export default {
    name: "ConsultApprove",
    components: {
      NoticeList,
      AddNotice
    },
    data() {
      return {
        active: 0,
        userTypes
      }
    },
    methods:{
      addConsult(){
        this.active =1;
      }
    },
    computed:{
      tabContent(){
        if (this.active===0){
          return AddNotice
        } else if(this.active === 1){
          return NoticeList
        } else {
          return  AddNotice
        }
      }
    }
  }
</script>

<style scoped>

</style>